// global
import React from 'react';
import PropTypes from 'prop-types';
// assets
import searchIcon from 'assets/icons/search-icons/search-icon-4b4b4b.svg';
import errorIcon from 'assets/icons/dropdown-icons/error-dropdown.svg';
// stylesheet
import styles from './SearchBox.module.scss';

// TODO #Autocomplete

function SearchBox(props) {
  const {
    onChange,
    onClick,
    value,
    label,
    placeholder,
    onKeyPress,
    size,
    error,
    showErrorMsg,
    message,
    disabled,
    inline,
    fullWidth
  } = props;

  const showError = () => {
    const { error: err /* , groupIndexes, repeated */ } = error;

    // const isRepetedQuestion = !!repeated;
    // if (isRepetedQuestion) {
    //   return err && (_.isEmpty(groupIndexes) || groupIndexes.includes(groupIndex));
    // }

    return err;
  };

  const variables = {
    '--direction': inline ? 'row' : 'column',
    '--align': inline ? 'center' : 'flex-start'
  };

  const style = () => {
    let style = disabled
      ? `${styles[size]} ${styles.disabled}`
      : showError()
      ? `${styles[size]} ${styles.error}`
      : value
      ? `${styles[size]} ${styles.value}`
      : styles[size];

    if (fullWidth) style += ` ${styles.fullWidth}`;

    return style;
  };

  return (
    <div className={style()} style={variables}>
      <label>{label}</label>
      <div>
        <div className={styles.container}>
          <input
            className={styles.searchDefault}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyPress}
            disabled={disabled}
          />
          {showError() && <img alt='error-icon' className={styles.errorIcon} src={errorIcon} />}
          <button disabled={disabled} onClick={onClick}>
            <img src={searchIcon} alt='search icon' />
          </button>
        </div>
        {showErrorMsg && showError() ? (
          <small className={styles.errorMessage}>{error.error}</small>
        ) : message ? (
          <small className={styles.message}>{message}</small>
        ) : null}
      </div>
    </div>
  );
}

SearchBox.defaultProps = {
  label: 'Pesquisar',
  placeholder: 'Buscar...',
  size: 'small',
  error: {
    error: null
    // groupIndexes: [],
    // repeated: false
  },
  showErrorMsg: true,
  inline: false,
  fullWidth: false
};

SearchBox.propTypes = {
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  popupSearchText: PropTypes.string,
  onKeyPress: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  error: PropTypes.shape({
    error: PropTypes.string
    // groupIndexes: PropTypes.array,
    // repeated: PropTypes.bool
  }),
  showErrorMsg: PropTypes.bool,
  message: PropTypes.string,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  fullWidth: PropTypes.bool
};

export default SearchBox;
